// Geometria paramétrica dos móveis Mini Marcenaria — catálogo 2026 R3.
//
// As fórmulas por modelo ficam em arquivos separados por categoria em
// ./geometria/. Este arquivo é só o ponto de entrada: ele re-exporta
// preços, helper, calcularCusto e o GEOMETRIA já montado.

import { PRECOS_MDF, PRECOS_FERRAGEM, p, calcularCusto as calcularCustoCore } from './geometria/core.js'
import { MESAS } from './geometria/mesas.js'
import { ESTANTES } from './geometria/estantes.js'
import { ROUPEIROS } from './geometria/roupeiros.js'
import { MALEIROS } from './geometria/maleiros.js'
import { COMODAS_SAPATEIRAS_BAUS } from './geometria/comodas-sapateiras-baus.js'
import { BALCOES_BUFFETS_RACKS } from './geometria/balcoes-buffets-racks.js'
import { ARMARIOS } from './geometria/armarios.js'
import { GAVETEIROS } from './geometria/gaveteiros.js'

export { PRECOS_MDF, PRECOS_FERRAGEM, p }

export const GEOMETRIA = {
  ...MESAS,
  ...ESTANTES,
  ...ROUPEIROS,
  ...MALEIROS,
  ...COMODAS_SAPATEIRAS_BAUS,
  ...BALCOES_BUFFETS_RACKS,
  ...ARMARIOS,
  ...GAVETEIROS,
}

export function calcularCusto(modeloNome, vars, tipoCor, perdaPct = 0.10) {
  return calcularCustoCore(GEOMETRIA, modeloNome, vars, tipoCor, perdaPct)
}
